var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('menu-button',{attrs:{"command":_vm.openEditLinkDialog,"title":"Edit link","icon":"linkEdit"}}),_c('link-dialog',{attrs:{"title":"Edit link","is-update-link":true,"is-visible":_vm.isVisible,"href":_vm.href,"target":_vm.target},on:{"close":_vm.closeEditLinkDialog,"click":_vm.updateLinkAttrs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }